export const LOG_IN = "LOG_IN";
export const LOG_OUT = "LOG_OUT";
export const SET_VARS = "SET_VARS";
export const SET_REGIONES = "SET_REGIONES";
export const SET_REGION = "SET_REGION";
export const SET_MESES = "SET_MESES";
export const SET_MES = "SET_MES";
export const SET_WEEK = "SET_WEEK";
export const SET_ACTIVOS = "SET_ACTIVOS";
export const SET_LANG = "SET_LANG";